import type { StoxlyClient } from '@stoxly/api-client';
import type { Body } from '../op-types';

/**
 * Peer comparison (fox F9). Both ops are POSTs — the symbol set is a body, not a path — so
 * both live here as mutations rather than in a query factory.
 *
 * They answer two DIFFERENT questions over the same group, which is why the second one
 * exists at all: `getPeerComparison` returns metrics (and ranks whatever companies THAT
 * request carried), while `getGroupRankings` ranks a whole group and returns the rankings
 * alone. The Compare page fetches metrics in batches of three, which can never clear the
 * backend's five-member percentile floor, so its percentiles come from one call to the
 * latter over the full discovered set.
 */
export function createComparisonMutations(client: StoxlyClient) {
  return {
    getPeerComparison: {
      mutationFn: (body: Body<'comparisonGetPeerComparison'>) =>
        client.comparisonGetPeerComparison(body),
    },
    getGroupRankings: {
      mutationFn: (body: Body<'comparisonGetGroupRankings'>) =>
        client.comparisonGetGroupRankings(body),
    },
  };
}
